'use client'

/**
 * Purpose: Identifies the PostHog person by the pseudonymous user id (cuid),
 * once per mount/session change. Data minimization: email/name are
 * deliberately NOT sent to PostHog.
 * Inputs: none directly — reads the current next-auth session via
 * `useSession()`.
 * Outputs: none (renders nothing); side effect is a PostHog `identify` call
 * via `identifyPostHogUser`.
 */

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { identifyPostHogUser } from '@lib/posthog-identity'

export function PostHogIdentify() {
  const { data: session } = useSession()
  const userId = session?.user?.id

  useEffect(() => {
    if (!userId) return
    identifyPostHogUser(userId, {
      user_id: userId,
    })
  }, [userId])

  return null
}
